import { render, staticRenderFns } from "./MeetingWhiteboardDesktop.vue?vue&type=template&id=5c2262e1&scoped=true"
import script from "./MeetingWhiteboardDesktop.vue?vue&type=script&lang=js"
export * from "./MeetingWhiteboardDesktop.vue?vue&type=script&lang=js"
import style0 from "./MeetingWhiteboardDesktop.vue?vue&type=style&index=0&id=5c2262e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2262e1",
  null
  
)

export default component.exports